import { ChangeDetectionStrategy, Component, inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider';
import { Subject, takeUntil } from 'rxjs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ThreeGraphqlService } from 'src/app/core/graphql/three/services/three-graphql.service';
import { ThreedProjectPreset } from '../../../services/project-controller/project-controller';
import { base64ToFile } from 'src/app/core/utils';

@Component({
  selector: 'app-preset-dialog',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDividerModule,
    FormsModule,
    MatButtonModule,
    MatDialogClose,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatInputModule,
  ],
  templateUrl: './preset-dialog.component.html',
  styleUrl: './preset-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PresetDialogComponent implements OnDestroy {
  public readonly dialogRef = inject(MatDialogRef<PresetDialogComponent>);
  public readonly data = inject<any>(MAT_DIALOG_DATA);
  private readonly threeGraphqlService = inject(ThreeGraphqlService);

  public isLoading: boolean = false;

  public presetName: FormControl = new FormControl('', [Validators.required]);

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
    this._unsubscribeAll.unsubscribe;
  }

  public onClickSave(): void {
    this.isLoading = true;
    const thumbnailFileName = `${new Date().getFullYear()}${new Date().getMonth()}${new Date().getDay()}${new Date().getHours()}${new Date().getMinutes()}${new Date().getSeconds()}`;
    console.log(this.data);
    base64ToFile(this.data.thumbnail as string, thumbnailFileName, 'image').then(
      (thumbnailFile: File) => {
        this.data.data.thumbnail = thumbnailFile;
        this.data.data.title = this.presetName.value;
        if (!this.data.uuid) return;
        this.threeGraphqlService
          .createProjectPreset(this.data.uuid, this.data.data)
          .pipe(takeUntil(this._unsubscribeAll))
          .subscribe((preset: ThreedProjectPreset) => {
            this.dialogRef.close(preset);
            this.isLoading = false;
          });
      },
    );
  }
}
